import { useToggle } from '@/hooks';
import { BlockStack, Box, Collapsible, Icon, InlineStack, Text } from '@shopify/polaris';
import { ChevronDownIcon, ChevronUpIcon } from '@shopify/polaris-icons';
import { memo } from 'react';

interface CollapsibleSectionProps {
  title: string;
  content: JSX.Element;
  index: number;
}
function CollapsibleSection({ title, content, index }: CollapsibleSectionProps) {
  const [collapsible, setCollapsible] = useToggle<boolean>(true);

  return (
    <div onClick={() => !collapsible && setCollapsible()} style={{ cursor: collapsible ? 'default' : 'pointer' }}>
      <Box padding="200" borderColor="border" borderWidth="025" borderRadius="200" shadow="200">
        <BlockStack gap="100">
          <InlineStack align="space-between" blockAlign="start">
            <Text as="p" variant="bodyMd" fontWeight="semibold">
              {title}
            </Text>
            <span
              onClick={(e) => {
                e.stopPropagation();
                setCollapsible();
              }}
              style={{ cursor: 'pointer' }}
            >
              <Icon source={collapsible ? ChevronUpIcon : ChevronDownIcon} tone="base" />
            </span>
          </InlineStack>
          <Collapsible key={index} open={collapsible} id={`${index}`}>
            <Text as="p" variant="bodyMd">
              {content}
            </Text>
          </Collapsible>
        </BlockStack>
      </Box>
    </div>
  );
}

export default memo(CollapsibleSection);
